import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class MetmindDashboardDataService {

  urlConst: any = environment.url.HEATWAVE_STAGING_API_URL;

  constructor(private http: HttpClient) { }

  getEventsData(date:any) {
    let url = 'https://metwise.vassarlabs.com/metMindApi/api/v1/events?date=' + date;
    return this.http.get<any>(url);
  }

  getArticlesDataForState(key: any, date:any) {
    let url = 'https://metwise.vassarlabs.com/metMindApi/api/v1/events/details?event_key=' + key + '&date=' + date;
    return this.http.get<any>(url);
  }

  formatLabel(str: any): string {
    if (isNullOrUndefined(str)) { return '-'; }
    return String(str).split('_').map(w => w.charAt(0) + w.slice(1).toLowerCase()).join(' ');
  }

  buildLabelStringsForDateRange(pastDays: number): any[] {
    let labels: any[] = [];
    for (let i = pastDays; i >= 0; i--) {
      let date = new Date();
      date.setDate(date.getDate() - i);
      let formattedDate = this.formatDateToDDMMYYYY(date);
      labels.push({
        groupName: formattedDate,
        label: { label: formattedDate, toolTip: formattedDate },
        fullLabel: formattedDate
      });
    }
    return labels;
  }

  formatDateToDDMMYYYY(date: Date): string {
    let dd = String(date.getDate()).padStart(2, '0');
    let mm = String(date.getMonth() + 1).padStart(2, '0');
    let yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
}
